import { Box as Flex } from '@material-ui/core';

import {
  RiBold,
  RiCodeLine,
  RiItalic,
  RiStrikethrough,
  RiUnderline,
} from '@remixicon/react';
import { useEditorState } from '@tiptap/react';

import { useCurrentEditor } from './Context';
import { AddLinkButton } from './Link/AddLinkButton';
import { TextColorButton } from './TextColorButton';
import { ToolbarButton } from './ToolbarButton';

export const InlineFormatButtons = () => {
  const { editor } = useCurrentEditor();

  const isActiveBold = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('strong') ?? false,
  });

  const isActiveItalic = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('em') ?? false,
  });

  const isActiveUnderline = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('underline') ?? false,
  });

  const isActiveStrike = useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('strike') ?? false,
  });

  const isActiveCode = !!useEditorState({
    editor,
    selector: ctx => ctx.editor?.isActive('code') ?? false,
  });

  return (
    <Flex
      display="flex"
      alignItems="center"
      style={{
        gap: 2,
      }}
    >
      <ToolbarButton
        active={isActiveBold ?? false}
        onClick={() => editor?.chain().focus().toggleBold().run()}
        disabled={isActiveCode}
        aria-label="Bold"
        aria-pressed={isActiveBold ?? false}
       data-track-source-anchor="9b652a696e">
        <RiBold />
      </ToolbarButton>
      <ToolbarButton
        active={isActiveItalic ?? false}
        onClick={() => editor?.chain().focus().toggleItalic().run()}
        disabled={isActiveCode}
        aria-label="Italic"
        aria-pressed={isActiveItalic ?? false}
       data-track-source-anchor="5bd7e9422d">
        <RiItalic />
      </ToolbarButton>
      <ToolbarButton
        active={isActiveUnderline ?? false}
        onClick={() => editor?.chain().focus().toggleUnderline().run()}
        disabled={isActiveCode}
        aria-label="Underline"
        aria-pressed={isActiveUnderline ?? false}
       data-track-source-anchor="466d262dc2">
        <RiUnderline />
      </ToolbarButton>
      <ToolbarButton
        active={isActiveStrike ?? false}
        onClick={() => editor?.chain().focus().toggleStrike().run()}
        disabled={isActiveCode}
        aria-label="Strikethrough"
        aria-pressed={isActiveStrike ?? false}
       data-track-source-anchor="b79cdc2178">
        <RiStrikethrough />
      </ToolbarButton>
      <TextColorButton  data-track-source-anchor="ea0a54f171;inline-format-buttons-text-color-button"/>
      <AddLinkButton  data-track-source-anchor="309ae9cdb1;inline-format-buttons-add-link-button"/>
      <ToolbarButton
        active={isActiveCode}
        onClick={() => editor?.chain().focus().toggleCode().run()}
        aria-label="Code"
       data-track-source-anchor="9408d89cfe">
        <RiCodeLine />
      </ToolbarButton>
    </Flex>
  );
};
